export abstract class FetchFollowersListByUserIdQuery {
  abstract exec(props: FetchFollowersListByUserIdQuery.Props): Promise<any>;
}

export namespace FetchFollowersListByUserIdQuery {
  export type Props = {
    isForCoach?: boolean;
    userId: string;
  };
}
